
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 41 41"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.5.5h0A19.988 19.988 0 004.308 32.222l-2.493 7.43L9.5 37.195A20 20 0 1020.5.5zm11.642 28.242c-.483 1.363-2.4 2.493-3.925 2.823-1.045.222-2.41.4-7.005-1.5-5.877-2.435-9.662-8.408-9.957-8.8S8.88 18.1 8.88 15.233a6.385 6.385 0 012.045-4.868 2.906 2.906 0 012.045-.718c.248 0 .47.013.67.023.587.025.883.06 1.27.988.483 1.162 1.658 4.033 1.8 4.327a1.19 1.19 0 01.085 1.083 3.456 3.456 0 01-.648.917c-.3.34-.575.6-.87.965-.27.318-.575.658-.235 1.245a17.752 17.752 0 003.245 4.032 14.7 14.7 0 004.69 2.893 1.265 1.265 0 001.41-.222 24.2 24.2 0 001.563-2.07 1.116 1.116 0 011.435-.435c.54.188 3.4 1.6 3.985 1.892s.975.435 1.117.683a4.981 4.981 0 01-.345 2.774z","fill":"none","stroke":"#707070"}})])
          )
        }
      }
    